import script from "./bindCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./bindCustomer.vue?vue&type=script&setup=true&lang=js"

import "./bindCustomer.vue?vue&type=style&index=0&id=01f42585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f42585"]])

export default __exports__